import React from 'react';
import Loadable from 'react-loadable';
import Loading from '../shared/components/Loading';

const QuickViewControllerAsync = Loadable({
  loader: () => import('../quickView/components/QuickView' /* webpackChunkName: 'qv' */),
  loading: () => {
    return (<Loading spinnerSrc={window.imageAssets.loading} />);
  },
});

export default QuickViewControllerAsync;



// WEBPACK FOOTER //
// ./src/reactjs/quickView/QuickViewControllerAsync.jsx